'use strict';

ReactTemplates.admin.fields = window.AdminFieldPage;
